/* istanbul ignore file */
import React, { useCallback, useState } from 'react';
import { CreateForm } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import useProcessIssueService from 'domain/gpo/cockpit/instance/Show/issues/shared/ProcessIssuesService';
import CloseProcessIssueForm from 'domain/gpo/cockpit/instance/Show/issues/CloseProcessIssueForm';

const MESSAGE_CONTEXT = 'closeIssueForm';

interface CloseProcessIssueModalFormProps {
  issueId: string;
  updateIssue: () => void;
  closeModal: () => void;
}

const CloseProcessIssueModalForm = ({ issueId, updateIssue, closeModal }: CloseProcessIssueModalFormProps) => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const { closeTicket, getValidationSchema } = useProcessIssueService();

  const closeForm = useCallback(() => {
    setIsModalOpen(false);
    closeModal();
  }, [setIsModalOpen, closeModal]);

  return (
    <CreateForm
      submitFormFunc={closeTicket}
      messageContext={MESSAGE_CONTEXT}
      getValidationSchemaFunc={getValidationSchema}
      initialData={{
        issueIds: [issueId],
        comment: '',
      }}
      afterSubmit={{
        execute: useCallback(() => {
          updateIssue();
          closeForm();
        }, [closeForm, updateIssue]),
      }}
    >
      <Modal
        key="modal-not-strict"
        modalSize="sm"
        backdrop="static"
        keyboard={false}
        isOpen={isModalOpen}
        hasCancelButton={false}
        onToggle={closeForm}
      >
        <CloseProcessIssueForm handleCancelClick={closeForm} />
      </Modal>
    </CreateForm>
  );
};

export default CloseProcessIssueModalForm;
